import { Alert, Clickable, List } from '@ahmdigital/ui';
import { isEmpty, map, reverse } from 'lodash/fp';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { ProductTypeType } from '../../../../../../types/product';
import { scrollToElement } from '../../../../../../utils/ui';
import selectBuildYourCover from '../../../../../../selectors/select-build-your-cover';

const BoldClickable = styled(Clickable)`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

interface ValidationAlertProps {
  hospitalSectionRef: React.RefObject<HTMLDivElement>;
  extrasSectionRef: React.RefObject<HTMLDivElement>;
}

const ValidationAlert = ({ hospitalSectionRef, extrasSectionRef }: ValidationAlertProps): JSX.Element | null => {
  const { invalidProductTypes } = useSelector(selectBuildYourCover);
  const errorRef = React.createRef<HTMLDivElement>();
  useEffect(() => {
    if (!isEmpty(invalidProductTypes) && errorRef.current) {
      scrollToElement(errorRef.current);
    }
  }, [invalidProductTypes]);

  if (isEmpty(invalidProductTypes)) {
    return null;
  }

  const scrollToError = (productType: ProductTypeType) => {
    scrollToElement((productType === 'hospital' ? hospitalSectionRef : extrasSectionRef).current);
  };

  return (
    <div ref={errorRef}>
      <Alert heading="Please select your cover to continue." level="danger">
        <List variant={['inside']}>
          {map(
            (productType) => (
              <li key={`choose-your-cover-error-missing-${productType}`}>
                Select <BoldClickable onClick={() => scrollToError(productType)}>{productType} cover</BoldClickable>
              </li>
            ),
            reverse(invalidProductTypes), // to ensure hospital first
          )}
        </List>
      </Alert>
    </div>
  );
};

export default ValidationAlert;
